import axios from "axios";
import {getAPIBaseUrlVersion1 } from "../utils/constants";
import { appendQueryString, buildQueryString, formUrlEncodedConfig } from "./serviceUtils";

const state = window.location.origin;
const apiUrl = getAPIBaseUrlVersion1();

export const login = (data, loginWithEmail) => {
  return axios.post(
    loginWithEmail ? `${apiUrl}/login` : `${apiUrl}/ldap_auth`,
    data
  );
};

export const sendForgotPasswordlink = async (data) => {
  return await axios.post(`${apiUrl}/forget_password/send_link`, data);
};

export const checkLinkValid = async (data) => {
  return await axios.get(
    `${apiUrl}${appendQueryString(`/check-valid-link`, buildQueryString({ uuid: data }))}`
  );
};

export const forgotPassword = async (data) => {
  return await axios.post(`${apiUrl}/forget_password`, data, formUrlEncodedConfig);
};

export const changePassword = async (data, token) => {
  return await axios.put(`${apiUrl}/change_password`, data, {
    headers: { ...formUrlEncodedConfig.headers, token },
  });
};

export const refreshToken = async (refresh_token) => {
  return await axios.post(`${apiUrl}/refresh-token`, {}, {
    headers: { "refresh-token": refresh_token },
  });
};

export const apiGoogleLogin = async () => {
  return axios.get(
    `${apiUrl}${appendQueryString(`/google/login`, buildQueryString({ domain: state }))}`
  );
}
